<form
  [formGroup]="form"
  *transloco="let t; read: 'metric-settings-form'"
  class="metric-settings-form__container"
>
  <div class="metric-settings-form__header">{{ header }}</div>

  <div class="metric-settings-form__section">
    <div class="metric-settings-form__section-header">{{ t('display') }}</div>

    <div class="metric-settings-form__radio">
      @for (scoringRadio of scoringRadios; track scoringRadio.value) {
        <div class="metric-settings-form__radio-option">
          <xi-radio
            name="scoring"
            formControlName="scoring"
            [value]="scoringRadio.value"
            [label]="scoringRadio.label"
            color="CX"
          ></xi-radio>

          @if (scoringRadio.value === 'BOX') {
            <div class="metric-settings-form__box-dropdowns">
              <xi-dropdown
                select="single"
                formControlName="boxDirection"
                [data]="boxDirectionDos"
                [width]="120"
              ></xi-dropdown>

              <xi-dropdown
                select="single"
                formControlName="boxSize"
                [data]="boxSizeDos"
                [width]="100"
              ></xi-dropdown>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="metric-settings-form__section">
    <div class="metric-settings-form__section-header">{{ t('target-metric-scale') }}</div>

    <div class="metric-settings-form__scale">
      <div class="metric-settings-form__scale-label">{{ t('min') }}</div>

      <xi-dropdown
        select="single"
        formControlName="min"
        [data]="minDos"
        [width]="100"
      ></xi-dropdown>

      <div class="metric-settings-form__scale-label">{{ t('max') }}</div>

      <xi-input-field
        formControlName="max"
        type="number"
        [min]="2"
        [max]="1000"
        [width]="100"
      ></xi-input-field>
    </div>
  </div>
</form>
